import React, { useState, useEffect } from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import format from 'date-fns/format';
import { makeStyles, fade } from '@material-ui/core/styles';
import { notificationCenterWidth, RightSideBarWidth } from '../../../../styleVariables';
import useMountEffect from '../../../../mountEffect';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../../../components/Dialog/Dialog';
import * as logger from "../../../../logger";
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import { connect } from 'react-redux';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import {
  updateChatView, toggleChatSupport, onlinePaymentsConfig
} from "../../../../store/actions/userActionCreators";
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { freshChat } from '../../../../configs/configs';
import FreshChat from 'react-freshchat';
import MobileStepper from '@material-ui/core/MobileStepper';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { biltyContinueClick } from '../../../../store/actions/tripActionCreator';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ExcelIcon, PdfIconWhite } from '../../../../components/icons';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { getPartiesTrips, getShopKhataData, getSuppliersWithBalance,getTripDetailsSimplified } from '../../../../store/actions/homeActionCreator';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { numberFormat, numberWithCommas,getDateInStringDDMMMYYYY, getVehicleNumberValuesDWeb, validNumberCheck, replaceCommas, findArrayObject } from '../../../../utils/utils';
import Highlighter from "react-highlight-words";
import { Form } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import { InputAdornment } from '@material-ui/core';
import { getBankDetails, getPaymentLink } from '../../../../store/actions/OnlinePaymentActionCreators';
import AddIcon from '@material-ui/icons/Add';
import { trackDwebEvent } from '../../../analytics';
import { getUserDetails } from '../../../../store/actions/authActionCreators';
import CustomDateFilterDialog from '../../../components/FilterComponent/CustomDateFilter';
import DateFilter from '../../../components/FilterComponent/DateFilter';
import TripStatusFilter from '../../../components/FilterComponent/TripStatusFIlter';
import { getTripStartDateFilterValues } from '../../../../utils/utils';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../../paginationVariables';
import { debounce } from 'lodash';
import {
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  TRIP_FILTER_STATUS,
  TRIP_FILTER_STATUS_MAPPING,
  PAYMENT_CHIPS,
  TRIP_STATUS_LABELS
} from "../../../../store/constants";
import { tripTableHeight,tripSideBarTableHeight, tableHeightWithSparkline } from "../../../../styleVariables";
import moment from 'moment';
import MUIDataTable from "mui-datatables";
import Chip from '@material-ui/core/Chip';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import TripDetailsDialog from '../../../components/Dialog/TripDetailsDialog';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
const useStyles = makeStyles(theme => ({
  transactionDetailsDrawer: {
    width: 750,
    maxWidth: 750,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  backdrop: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    }
  },
  container: {
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1,
    flexGrow: 1
  },
  sideBarDialogContentV1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    backgroundColor: '#fff'
  },
  divTitle: {
    display: 'flex',
    alignItems: 'center',
    color: "#0b1323",
    fontSize: 18,
    marginBottom: 4
  },
  divSecTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: "rgba(11, 19, 35, 0.75);",
    marginBottom: 8
  },
  titleDiv: {
    display: 'flex',
    flexDirection: 'column'
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#fff",
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    border: "solid 1px rgba(11, 19, 35, 0.5)",
    marginRight: 0,
    marginLeft: 0,
    //width: '100%',
  },
  sicon: {
    fontSize: 18
  },
  searchIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    fontSize: 14,
    padding: "9px 0px",
    //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    width: '100%'
  },
  sideBarActions: {
    paddingTop: 24,
    paddingBottom: '24px !important',
    paddingRight: 30,
    paddingLeft: 30,
    backgroundColor: 'white'
  },
  subTitleSec: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  bankSubTitleSec: {
    marginBottom: 2,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:last-child': {
      marginBottom: 0
    }
  },
  listingDiv: {
    marginTop: 24
  },
  subTitleTxt: {
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(11, 19, 35, 0.5)"
  },
  driverDiv: {
    padding: 16,
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    //transition:'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    marginBottom: 12,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'cente',
    justifyContent: 'space-between'
  },
  nameDiv: {
    display: 'flex',
    flexDirection: 'column',
    //alignItems:'center',
    fontSize: 16
  },
  bankValueDiv: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 16
  },
  balanceDiv: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },
  listDriverBalance: {
    fontWeight: 600
  },
  listDriverBalancePositive: {
    fontWeight: 600,
    color: "#379953"
  },
  listDriverBalanceZero: {
    fontWeight: 600,
    color: "#0b1323"
  },
  listDriverBalanceNegative: {
    fontWeight: 600,
    color: "#ff0000"
  },
  highlight: {
    color: "#1860f0",
    padding: 0
  },
  verifiedAccount: {
    fontSize: 12,
    color: "rgba(21, 128, 38, 0.6)"
  },
  unVerifiedAccount: {
    fontSize: 12,
    color: "#e93333"
  },
  valueTxt: {
    textTransform: 'capitalize',
    fontWeight: 600
  },
  valueTxt1: {
    textTransform: 'capitalize',
  },
  alignEnd: {
    textAlign: 'end'
  },
  payNowButton: {
    marginLeft: 16,
    padding: '6px 30px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#09101e',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#09101e",
    }
  },
  viewPdfButton: {
    padding: '6px 12px',
    borderRadius: 4,
    border:"1px solid #dcdcdc",
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 600,
    color: '#0033cc',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#fff",
    }
  },
  balance: {
    color: "rgba(11, 19, 35, 0.75)",
    fontSize: 12,
    paddingLeft: 8,
    textTransform: 'uppercase'
  },
  driverName: {
    fontSize: 12
  },
  emptyStateDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  emptyTxt: {
    color: "#787878",
    marginTop: 32,
    textAlign: 'center'
  },
  addCta: {
    backgroundColor: "#0033cc",
    textTransform: "uppercase",
    fontWeight: 600,
    color: '#fff',
    paddingTop: 17,
    paddingBottom: 17,
    borderRadius: 8,
    width: '100%',
    '&:hover': {
      backgroundColor: "#0033cc",
    }
  },
  divTripListing: {
    display: 'flex', alignItems: 'center', justifyContent: 'flex-end'
  },
  divDateTripListing: {
    color: '#9ea0a5',
    fontSize: 13,
    textAlign: 'start',
    marginTop: '-20px',
    marginBottom: 2,
  },
  divTripStatusTripListing: {
    color: '#9ea0a5',
    fontSize: 13,
    textAlign: 'start',
    marginTop: '-20px',
    marginBottom: 2,
  },
  mtV2TripListing: {
    display: 'flex',
  },
  dateFilter: {
    '& .MuiButton-root': {
      borderRadius: 16
    }
  },
  statusFilter: {
    marginLeft: 10,
    '& .MuiButton-root': {
      borderRadius: 16
    }
  },
  partyName: {
    fontSize: 14,
    marginLeft: 16
  },
  tripListingRoot: {
    display: 'flex',
    //justifyContent: 'center',
    alignItems: 'center',
    color:"#5e636c"
  },
  customFooter:{
    display:'flex',
    flexDirection:'row',
    justifyContent:'space-between',
    alignItems:'center',
    backgroundColor:"#00875a",
    padding:"12px 24px",
    fontSize:16,
    color:'#fff',
    fontWeight:600,
    borderBottomLeftRadius:4,
    borderBottomRightRadius:4
  },
  infoOutlinedIcon:{
    fontSize:14,
    color:"#0033cc",
    marginLeft:2
  },
  balancePartyTripListingTable:{
    "& .MuiToolbar-regular":{
      display:'none'
    }
  },
  balancePartyListingTable:{
    "& .MuiToolbar-regular":{
      display:'none'
    }
  },
  arrowIcon:{
    color:"#6d717b",
    fontSize:16,
    margin:"0px 4px"
  },
  vehileNumber: {
    fontSize: 14,
    "&:last-child": {
      color: '#0033cc',
      marginLeft: 6
    },
    "&:first-child": {
      marginRight: 6
    },
    "&:nth-last-child(2)": {
      marginLeft: 6
    }
  }
}));

const SupplierBalanceReportSideBar = ({
  rightSideBarOpen,
  toggleRightSideBar,
  user,
  defaultData,
  children,
  sideBarName,
  sideBarTitle,
  sideBarSecondaryTitle,
  handleSubmit,
  fromSingleShop,
  dispatchChatView,
  dispatchFetchBankDetails,
  dispatchGetUserDetails,
  dispatchGetOnlinePaymentsConfig,
  dispatchGetShopsDataAction,
  dispatchFetchSuppliers,
  dispatchFetchSupplierTrips,
  dispatchSingleTripDetails
}) => {
  let submit, formValues;
  const classes = useStyles();
  const [updateChatView, setChatView] = useState(false);
  const [progress, setProgress] = useState(25);
  const [successCreation, setSuccessCreation] = useState(false);
  const [failureCreation, setFailureCreation] = useState(false);
  const [shopSearchTxt, setShopSearchTxt] = useState("");
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [selectedSingleSupplier, setSelectedSingleSupplier] = useState(null);
  const [supplierListData, setSupplierListData] = useState([]);
  const [tripListData, setTripListData] = useState([]);
  const [amount, setAmount] = useState(null);
  const [reason, setReason] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [configInfo, setConfigInfo] = useState({});
  const [addShopOpen, setAddShopOpen] = useState(false);
  const [recall, setRecall] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedFilterStatus, setSelectedFilterStatus] = useState("ACTIVE");
  const [selectedFilterDate, setSelectedFilterDate] = useState("ALL_MONTHS");
  const [changeFlag, setChangeFlag] = useState(false);
  const [customFilter, setCustomFilter] = useState(false);
  const [customFilterValue, setCustomFilterValue] = useState({});
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
  const [defaultDataValue, setDefaultDataValue] = useState({});
  const [tripDetailsOpen,setTripDetailsOpen] = useState(false)
  const [singleTripDetails,setSingleTripDetails] = useState({})
  const [rowsSelected,setRowSelected] = useState([]);


  let dateFilterValues = getTripStartDateFilterValues();
  const getDateRangeValue = () => {
    let date = `${moment(dateFilterValues[selectedFilterDate]["startDateRange"]["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(dateFilterValues[selectedFilterDate]["startDateRange"]["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    if (customFilterValue && customFilterValue.startTimeEpoch) {
      date = `${moment(customFilterValue["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(customFilterValue["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    }
    return [date]
  }

  const handleViewPdf = () => {
    setPdfDialogOpen(true);
    // ************************************** Mapping respected default values from filters and party selection table in to common object , to pass across components **************************************
    const defaultData = {
      entityIds: [],
      tripStatusFilter: "",
      dateFilterStatus: "",
    }

    defaultData.dateFilterStatus = selectedFilterDate;
    defaultData.tripStatusFilter = selectedFilterStatus;

    // Formatting the list of suppliers selected into required format.
    selectedSuppliers.map((rowData, index) => {
      if (rowData && supplierListData && supplierListData[rowData.dataIndex] && supplierListData[rowData.dataIndex].vendorId) {
        // Pushing customerId and customerName into entityIds array.
        defaultData.entityIds.push(
          supplierListData[rowData.dataIndex].vendorId
        )
      }
    });

    if (customFilterValue) {
      defaultData.customDateRange = customFilterValue
    }

    setDefaultDataValue(defaultData);
  }

  const handleClosePdf = () => {
    setPdfDialogOpen(false);
  }
  const handleTripDetailsClose = ()=>{
    setTripDetailsOpen(false)
    setSingleTripDetails({})
  }
  /*useEffect(() => {

    if (user && user.onlinePaymentConfig) {
      setConfigInfo(user.onlinePaymentConfig);
    } else {
      setConfigInfo({});
    }

  }, [user.onlinePaymentConfig]);

  useEffect(() => {

    if (user && user.userInfoProfile) {
      setUserInfo(user.userInfoProfile);
    }

  }, [user.userInfoProfile]);*/
  const handleAddShopClick = () => {
    setAddShopOpen(true);
  }
  const onSearchBlur = debounce(query => {
    setSupplierListData([])
    const tripLedgerRequestData = {
      vendorSearchText: query,
      tripStatus: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
      dateRange: dateFilterValues[selectedFilterDate]["startDateRange"]
    };
    if (customFilterValue && customFilterValue.startTimeEpoch) {
      tripLedgerRequestData.dateRange = customFilterValue
    }
    dispatchFetchSuppliers(tripLedgerRequestData,
      (response) => {
        if (response && response.status && response.status.code == 200 && response.vendorList && response.vendorList.length > 0) {
          setSupplierListData(response.vendorList)
        }
      },
      () => {
      })
  }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
  useEffect(() => {
    setSupplierListData([])
    const tripLedgerRequestData = {
      vendorSearchText: searchText,
      tripStatus: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
      dateRange: dateFilterValues[selectedFilterDate]["startDateRange"]
    };
    if (customFilterValue && customFilterValue.startTimeEpoch) {
      tripLedgerRequestData.dateRange = customFilterValue
    }
    dispatchFetchSuppliers(tripLedgerRequestData,
      (response) => {
        if (response && response.status && response.status.code == 200 && response.vendorList && response.vendorList.length > 0) {
          setSupplierListData(response.vendorList)
        }
      },
      () => {
      })
  }, [dispatchFetchSuppliers, recall, customFilterValue]);

  useEffect(() => {
    dispatchChatView(false);
  }, []);

  const handleClose = (fromResponse) => {
    if (toggleRightSideBar) {
      toggleRightSideBar()
    }
    dispatchChatView(true);
  }

  const handleDateValue = (value) => {
    if (value == "CUSTOM") {
      setCustomFilter(true);
    }
    else {
      setSelectedFilterDate(value);
      setCustomFilter(false);
      setCustomFilterValue({});
      setRecall(!recall);
    }
  }

  const handleCustomFilterClose = () => {
    setCustomFilter(false);
  }

  const handleCustomFilterConfirm = (value) => {
    setSelectedFilterDate("CUSTOM");
    setCustomFilter(false);
    setCustomFilterValue(value);
  }

  const handleTripStatusValue = (value) => {
    setSelectedFilterStatus(value);
    setRecall(!recall);
  }
  const handleSave = () => {
    if (handleSubmit) {
      handleSubmit()
    }
    //dispatchChatView(true);
  }

  const validate = values => {

    const errors = {};
    let transactionLimit = 0;

    if (!values.amount) {
      errors.amount = 'Amount Required';
    }
    return errors;
  };

  let initialValues = {
    amount: amount,
    reason: reason
  };

  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
  };
  const handlePayNow = () => {
  }
  const muiData = supplierListData;
  const tripData = tripListData && tripListData.tripLogs?tripListData.tripLogs:[];
  const goToTripListingView = (data,index) => {
    setSelectedSuppliers([{dataIndex:index}])
    if (data && data.vendorId) {
      let requestData = {
        filters: [
          {
            "filterKey": "vendorId",
            "values": [data.vendorId]
          },
          {
            "filterKey": "tripStatus",
            "values": TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus]
          },
          {
            "filterKey": "startDate",
            "values": getDateRangeValue()
          }]
      }
      dispatchFetchSupplierTrips(requestData,
        (response) => {
          if (response && response.status && response.status.code == 200 && response.response && response.response.tripLogs && response.response.tripLogs.length > 0) {
            setSelectedSingleSupplier(data)
            setTripListData(response.response)
          }
        },
        () => {
        })
    }
  }
  const handleTripClick = (e,data)=>{
    e.preventDefault();
    e.stopPropagation();
    if(data && data.id){
      dispatchSingleTripDetails({
        id:data.id,
        type:"SUPPLIER"
      },
        (response) => {
          if (response && response.status && response.status.code == 200 && response.response) {
            setSingleTripDetails(response.response)
            setTripDetailsOpen(true)
          }
        },
        () => {
        })
    }
  }
  const muiColumns = [
    {
      name: "vendorName",
      label: "Supplier Name",
      options: {
        filter: false,
        sort: false,
        sortThirdClickReset: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let data = muiData[dataIndex];
          return <div>{data.vendorName}</div>;
        }
      },
    },
    {
      name: "activeTripCount",
      label: "No. of Trips",
      options: {
        filter: false,
        sort: false,
        sortThirdClickReset: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let data = muiData[dataIndex];
          return <div>{data && data.activeTripCount?data.activeTripCount:""}</div>;
        }
      },
    },
    {
      name: "vendorBalance",
      label: "Balance",
      options: {
        filter: false,
        sort: false,
        sortThirdClickReset: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let data = muiData[dataIndex];
          return <div style={{display:'flex',alignItems:'center'}}>
          <div style={{minWidth:80}}>{numberFormat(Number(data.vendorBalance))}</div>
          <ArrowForwardIosIcon className={classes.arrowIcon} />
        </div>;
        }
      },
    }
  ];
  const options = {
    rowsPerPage: 100,
    rowsPerPageOptions: [10, 100, 250],
    filterType: "multiselect",
    tableBodyHeight: tripTableHeight,
    selectableRows: 'multiple',
    selectableRowsHeader:false,
    rowsSelected:rowsSelected,
    selectToolbarPlacement: 'none',
    searchOpen: false,
    search: false,
    sort: false,
    jumpToPage: false,
    download: false,
    filter: false,
    print: false,
    pagination: false,
    viewColumns: false,
    sortOrder: {
      name: 'startDateTable',
      direction: 'desc'
    },
    onRowClick: (rowData, rowMeta) => {
      goToTripListingView(muiData[rowMeta.dataIndex],rowMeta.dataIndex)
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected, rows) => {
      setRowSelected(rows);
      setSelectedSuppliers(allRowsSelected);
    },
    customToolbar: (data) => {
      return <>
        <div className={classes.divTripListing}>
          <div className={classes.mtV2TripListing}>
            <span className={classes.dateFilter}>
              {/* <div className={classes.divDateTripListing}>Date</div> */}
              <DateFilter fromTripListing={true} dateValue={handleDateValue} />
            </span>
            <span className={classes.statusFilter}>
              {/* <div className={classes.divTripStatusTripListing}>Trip Status</div> */}
              <TripStatusFilter fromTripListing={true} status={handleTripStatusValue} defaultTripStatusFilter={selectedFilterStatus} />
            </span>
          </div>
        </div>
      </>
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

    },
    searchProps: {
      // value: searchText,
      variant: "outlined",
      InputProps: {
        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
      },
      onBlur: (e) => {
      },
      onKeyUp: (e) => {
      },
      onKeyDown: (event) => {
        if (event.keyCode === 27) {
        }
      }
    },
    searchPlaceholder: 'Search Suppliers',
    onSearchChange: (val) => {
      let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
      setSearchText(value);
      if (value && value.length > 1) {
        onSearchBlur(value)
      } else if (searchText && value && value.trim().length <= 1) {
        setSearchText("");
        onSearchBlur("")
      }else{
        setSearchText("");
        onSearchBlur("")
      }
    },
    onSearchClose: () => {
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = true;
      /*if (searchQuery && searchQuery.trim().length > 0) {
        searchQuery = searchQuery.trim()
        currentRow.forEach((col, index) => {
          if (index == 0) {
            col = getDatePickerDateInStringDDMMMYYYY(new Date(Number(col) * 1000));
          }
          if (col && col.toString().toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0) {
            isFound = true;
          }
        });
      } else {
        isFound = true;
      }*/
      return isFound;
    },
    textLabels: {
      body: {
        noMatch: "Sorry, no Suppliers found",
        toolTip: "Sort",
        columnHeaderTooltip: column => `Sort for ${column.label}`
      }
    }
  };
  const tripColumns = [
    {
        name: "startDate",
        label: "Start Date",
        options: {
          filter: false,
          sort: false,
          sortThirdClickReset: true,
          customBodyRenderLite: (dataIndex, rowIndex) => {
            let data = tripListData.tripLogs[dataIndex];
            return <div>{data && data.startDate?getDateInStringDDMMMYYYY(data.startDate):""}</div>;
          }
        },
    },
    {
      name: "startLocation",
      label: "Route",
      options: {
        filter: false,
        sort: false,
        sortThirdClickReset: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let data = tripListData.tripLogs[dataIndex];
          return <div>{data && data.startLocation ? data.startLocation : ""}&nbsp;{data && data.destinationLocation ? `to ${data.destinationLocation}` : ""}</div>;
        }
      },
    },
    {
      name: "vehicle",
      label: "Truck",
      options: {
        filter: false,
        sort: false,
        sortThirdClickReset: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let data = tripListData.tripLogs[dataIndex];
          const vehicleArray = data && data.vehicle && data.vehicle.vehicleNumber?getVehicleNumberValuesDWeb(data.vehicle.vehicleNumber):[]
          return <div>
             <div style={{ display: 'flex', textTransform: 'uppercase' }}>
                      {vehicleArray && vehicleArray.length > 2 && vehicleArray.map((item) => (
                          <div className={classes.vehileNumber}>{item}</div>
                      ))
                      }
                  </div>
          </div>;
        }
      },
    },
    {
      name: "vendorBalance",
      label: "Balance Amount",
      options: {
        filter: false,
        sort: false,
        sortThirdClickReset: true,
        setCellHeaderProps: value => {
          return {
            style: {
              textAlign:'right'
            },
          };
        },
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let data = tripListData.tripLogs[dataIndex];
          return <div style={{display:'flex',justifyContent:'flex-end'}}>
            <div style={{display:'flex',alignItems:'center'}}>
              <span>{numberFormat(Number(data && data.vendorBalance ? data.vendorBalance : 0))}</span>
              <InfoOutlinedIcon onClick={(e)=>{handleTripClick(e,data)}} className={classes.infoOutlinedIcon} />
            </div>
          </div>;
        }
      },
    }
  ];
  const tripTableOptions = {
    rowsPerPage: 100,
    rowsPerPageOptions: [10, 100, 250],
    filterType: "multiselect",
    tableBodyHeight: tripSideBarTableHeight,
    searchOpen: false,
    search: false,
    sort: false,
    jumpToPage: false,
    download: false,
    filter: false,
    print: false,
    pagination: false,
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
      return (
      <div className={classes.customFooter}>
        <div>
          Total Balance Based on Trips :
        </div>
        <div>
          {numberFormat(tripListData && tripListData.totalSupplierBalance ?tripListData.totalSupplierBalance:0)}
        </div>
      </div>
      );
    },
    viewColumns: false,
    selectableRows: 'none',
    sortOrder: {
      name: 'startDateTable',
      direction: 'desc'
    },
    onRowClick: (rowData, rowMeta) => {
      ///goToTripListingView(muiData[rowMeta.dataIndex])
    },
    customToolbar: (data) => {
      return <>
      </>
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

    }
  };
  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={rightSideBarOpen}
      ModalProps={{
        keepMounted: false,
        className: classes.modal,
        BackdropProps: {
          className: classes.backdrop
        },
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        //onBackdropClick: handleClose
      }}
      classes={{
        paper: classes.transactionDetailsDrawer
      }}
    >
      <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} siderBarType={'truckBook'} onClose={handleClose}>
        <div className={classes.titleDiv}>
          <div className={classes.divTitle}>
            Supplier Balance Report
            {selectedSingleSupplier && selectedSingleSupplier.vendorName ? <span className={classes.partyName}>{selectedSingleSupplier.vendorName}</span> : ""}
          </div>
        </div>
      </SideBarDialogTitle >
      <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >
        {selectedSingleSupplier && selectedSingleSupplier.vendorId ? <div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
            <div className={classes.tripListingRoot}>
              <Chip style={{color:"#5e636c"}} label={dateFilterValues[selectedFilterDate]["value"]} />
              <Chip style={{marginLeft:12,color:"#5e636c"}} label={TRIP_FILTER_STATUS[selectedFilterStatus]} />
            </div>
            <div>
              <Button variant="contained" className={classes.viewPdfButton} onClick={() => { handleViewPdf() }} >
                <PictureAsPdfIcon />&nbsp;View PDF
              </Button>
            </div>
          </div>
          <div className={classes.balancePartyTripListingTable}>
            <MUIDataTable title={""} data={tripData} columns={tripColumns} options={tripTableOptions} />
          </div>
        </div> :<div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24}}>
            <div className={classes.search}>
              {!searchText && <div className={classes.searchIcon}>
                <SearchIcon className={classes.sicon} />
              </div>}
              {searchText && <div className={classes.closeIcon} onClick={(e) => { setSearchText("");onSearchBlur("")}}>
                <CloseIcon className={classes.sicon} />
              </div>}
              <InputBase
                placeholder="Search for Supplier"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                value={searchText}
                onChange={(e) => {
                  let val = e.target.value;
                  let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
                  setSearchText(value);
                  if (value && value.length > 1) {
                    onSearchBlur(value)
                  } else if (searchText && value && value.trim().length <= 1) {
                    setSearchText("");
                    onSearchBlur("")
                  }
                  if (!val && searchText) {
                    setSearchText("");
                    onSearchBlur("")
                  }
                }}
                inputProps={{ 'aria-label': 'search' }}
              />
            </div>
            <div className={classes.divTripListing}>
              <div className={classes.mtV2TripListing}>
                <span className={classes.dateFilter}>
                  {/* <div className={classes.divDateTripListing}>Date</div> */}
                  <DateFilter fromTripListing={true} dateValue={handleDateValue} deafultValue={selectedFilterDate} />
                </span>
                <span className={classes.statusFilter}>
                  {/* <div className={classes.divTripStatusTripListing}>Trip Status</div> */}
                  <TripStatusFilter fromTripListing={true} status={handleTripStatusValue} defaultTripStatusFilter={selectedFilterStatus} />
                </span>
              </div>
            </div>
          </div>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
              <div style={{color:"#464c58",fontSize:14,fontWeight:600}}>Choose Suppliers to view PDF</div>
              <div onClick={(e)=>{
                setRowSelected([...Array(muiData.length).keys()]);
                let selected = [...Array(muiData.length)].map((item, index) => {return{dataIndex:item}});
                setSelectedSuppliers(selected)
              }} style={{color:"#0033cc",fontSize:14,fontWeight:600,cursor:"pointer"}}>Select All Suppliers</div>
          </div>
          <div className={classes.balancePartyListingTable}>
          <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
        </div></div>}
      </SideBarDialogContent>
      <SideBarDialogActions className={classes.sideBarActions} >
        <div className={classes.divActionsPayment}>
          {selectedSingleSupplier && selectedSingleSupplier.vendorId ?
            <Button variant="contained" className='modal-close-cta' onClick={() => {
              setSelectedSingleSupplier(null);
              setTripListData([]);
              setSelectedSuppliers([])
              setRowSelected([])
            }} >
              Back
            </Button> : <>
              <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                Close
              </Button>
              <Button disabled={selectedSuppliers.length <= 0} variant="contained" className={classes.payNowButton} onClick={() => { handleViewPdf() }} >
                View PDF&nbsp;<PictureAsPdfOutlinedIcon />
              </Button>
            </>
          }
        </div>
      </SideBarDialogActions>
      {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}
      {pdfDialogOpen && <ReportsDialog open={pdfDialogOpen} name={"Supplier Ledger"} onClose={handleClosePdf} reportType={"excelReports"} defaultValueObject={defaultDataValue} />}
      {tripDetailsOpen && <TripDetailsDialog confirmOpen={tripDetailsOpen} details={singleTripDetails} mode="supplier" confirmTitle={"Amount Details"} confirmMessage={""} onClose={handleTripDetailsClose} />}
    </Drawer >
  );
};

SupplierBalanceReportSideBar.propTypes = {
  rightSideBarOpen: PropTypes.bool,
  toggleRightSideBar: PropTypes.func
};
const SupplierBalanceReportSideBarWithRouter = withRouter(SupplierBalanceReportSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchToggleChatSupport: (value) => dispatch(toggleChatSupport(value)),
  dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value)),
  dispatchFetchSuppliers: (data, onSuccess, onFailure) => (dispatch(getSuppliersWithBalance(data, onSuccess, onFailure))),
  dispatchSingleTripDetails: (data, onSuccess, onFailure) => (dispatch(getTripDetailsSimplified(data, onSuccess, onFailure))),
  dispatchFetchSupplierTrips: (data, onSuccess, onFailure) => (dispatch(getPartiesTrips(data, onSuccess, onFailure))),
  dispatchGetUserDetails: (onSuccess, onFailure) => { dispatch(getUserDetails(onSuccess, onFailure)) }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupplierBalanceReportSideBarWithRouter);
